import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";

export default function About() {
  return (
    <PublicLayout>
      <div className="bg-primary text-white py-12 px-4">
        <h1 className="font-display text-5xl text-center uppercase">About Us</h1>
      </div>
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="space-y-5 text-lg text-slate-700 leading-relaxed text-center">
          <p>
            At Fun-Nastix, we create a fun, supportive environment where children can grow in confidence, strength,
            and skill. Our after-school gymnastics classes are designed to help every child enjoy movement, develop
            new abilities, and feel proud of their progress.
          </p>
          <p>At Fun-Nastix, we believe in more than just gymnastics – we believe in growing confident, strong and happy children.</p>
          <p>
            Led by Level 4 Women's Artistic coach Vickie Moody - whose 30+ years of experience includes coaching at
            Dynamo Gymnastics and learning from global leaders in Moscow &amp; the USA - our fun, structured sessions
            help every child thrive.
          </p>
          <p>
            With expert guidance, a passion for teaching, and a safe, supportive environment, Fun-Nastix is where
            gymnasts grow from little jumps to big dreams.
          </p>
        </div>
        <div className="text-center mt-10">
          <Link to="/book-online">
            <Button data-testid="about-book-btn"
              className="rounded-full font-display text-2xl px-12 py-7 bg-primary text-white hover:bg-primary/90 hover:-translate-y-1 transition-transform">
              Book Online!
            </Button>
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
